// The "decide by" chip on a question card: the date Merlin proposed, read
// against today and the report's date (a date that passed after the report
// was written is "for the next meeting", not a failure — 2026-09-27
// assessment, kanban 929581ec). Shared by the Merlin's questions tab and the
// question pop-up through QuestionCard.

import { decideByFromQuestion, decideByState } from './roadmapViewUtils';
import { fmtDay, parseDay } from './roadmapTimelineUtils';
import styles from './RoadmapV2.module.css';

const STATE_LABEL = {
  overdue: 'was due',
  soon: 'due',
  later: 'due',
  awaiting: 'for the next meeting',
} as const;

function dueDay(iso: string): string {
  const d = parseDay(iso);
  return d ? fmtDay(d) : iso;
}

export function DecideByChip({ question, today, reportDate = null }: { question: string; today: string; reportDate?: string | null }) {
  const year = Number(today.slice(0, 4));
  const iso = decideByFromQuestion(question, year);
  if (!iso) {
    return (
      <span className={`${styles.decideBy} ${styles.decideBy_none}`} title="Merlin proposed no date for this one — ask it to, or set one in the meeting">
        no date proposed
      </span>
    );
  }
  const state = decideByState(iso, today, reportDate);
  if (state === 'awaiting') {
    return (
      <span
        className={`${styles.decideBy} ${styles.decideBy_awaiting}`}
        title={`Asked on ${reportDate}, proposed for ${iso}. Merlin resets the date on its next run; the question is not overdue.`}
      >
        {STATE_LABEL.awaiting} · asked {reportDate}, proposed {iso}
      </span>
    );
  }
  return (
    <span className={`${styles.decideBy} ${styles[`decideBy_${state}`]}`} title={`Proposed decide-by date: ${iso}`}>
      {STATE_LABEL[state]} {dueDay(iso)}
    </span>
  );
}
